export enum PaymentMethod {
  BANK = 'Bank',
  PAYPAL = 'Paypal',
  STRIPE = 'Stripe',
}

export enum PaymentStatus {
  CANCELED = 'payment_canceled',
  SUCCEEDED = 'payment_succeeded',
}
